export default __webpack_public_path__ + "static/media/caret.02538741.svg";